<template>
  <FullScreenDialog
    v-model="paymentDebitDialog"
    title="Nuova spesa per contanti"
    :routeFather="pathToGoBack"
  >
    <template v-slot:toolbar-extension>
      <v-tabs v-model="tab" align-with-title>
        <v-tabs-slider color="primary"></v-tabs-slider>
        <v-tab
          v-for="tab in paymentDebitTabs"
          :key="tab.key"
        >{{ tab.title }}</v-tab>
      </v-tabs>
    </template>
    <template v-slot:content>
      <v-tabs-items v-model="tab">
        <v-tab-item v-for="tabItem in paymentDebitTabs" :key="tabItem.key">
          <v-card flat>
            <component :is="tabItem.component"></component>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </template>
    <template v-slot:footer-actions>
      <v-spacer></v-spacer>
      <v-btn
        text
        color="error"
        @click="$router.push({path: pathToGoBack})"
      >Annulla</v-btn>
      <v-btn
        text
        color="default"
        :disabled="!formValid"
        @click="submitForm"
      >Salva</v-btn>
    </template>
  </FullScreenDialog>
</template>

<script>
import FullScreenDialog from "@/components/common/FullScreenDialog.vue";
import GeneralForm from "@/components/areas/payments/paymentDebits/operatorPaymentDebit/form/GeneralFormTab.vue"
import paymentDebitsService from '@/services/paymentDebits/paymentDebits.service.js'
import paymentDebitForm from '@/services/paymentDebits/paymentDebit.form.js'

export default {
  name: "PaymentDebitsNewForm",
  components: {
    FullScreenDialog,
    GeneralForm
  },
  data: function() {
    return {
      tab: null,
      paymentDebitDialog: this.openDialog,
      paymentDebitTabs: [
        {
          key: 0,
          title: "Generale",
          name: "general",
          component: "GeneralForm"
        }
      ],
      formValid: false,
      paymentDebit: undefined,
      originalUrl: window.location.pathname
    };
  },
  mounted() {
    this.changeTabBasedOnProp(this.tabName)

    let self = this
    paymentDebitForm.resetPaymentDebit()
    paymentDebitForm.updateField('type', 'operator')
    paymentDebitForm.updateField('documentType', 'receipt')
    
    paymentDebitForm.on('update', function(data) {
      self.paymentDebit = data.paymentDebit
    })

    paymentDebitForm.on('valid-change', function(data) {
      self.formValid = data
    })
  },
  props: {
    openDialog: {
      type: Boolean,
      default: false
    },
    pathToGoBack: {
      type: String,
      default: "/payments"
    },
    tabName: {
      type: String,
      default: 'general'
    }
  },
  methods: {
    changeTabBasedOnProp(tabName) {
      for(let i = 0; i < this.paymentDebitTabs.length; i++) {
        if(this.paymentDebitTabs[i].name == tabName) {
          this.tab = i
          break
        }
      }
    },
    submitForm() {
      paymentDebitsService.createAndPay(this.paymentDebit).then((result) => {
        this.$router.push({path: this.pathToGoBack})
      })
    }
  },
  watch: {
    openDialog(newVal) {
      this.paymentDebitDialog = newVal;
    },
    tab(newVal) {
      try {
        window.history.pushState("Tab", "Tab", this.originalUrl + '?tabName=' + this.paymentDebitTabs[newVal].name);
      } catch(err) {
        console.log('try setting the tab name but something goes wrong')
      }
    }
  },
  computed: {
  }
};
</script>